import VideoTrimSlider from './VideoTrimSlider';

export default VideoTrimSlider;

export { VideoTrimSlider };
